module.exports = __webpack_public_path__ + "media/images/flags/32/Turks-and-Caicos-Islands-59c44b357b1b0bf72660b3f4a3c887e2.png";